import { detect } from 'detect-browser'
import { create } from 'zustand'
import { mobileOSList, tabletUserAgent } from './constants'
import { shallow } from 'zustand/shallow'

const isProdOrStaging = ['production', 'staging', 'strabag'].includes(
  import.meta.env.VITE_TARGET_ENV
)

const initialState = {
  isProdOrStaging,
  windowWidth: window.innerWidth,
  windowHeight: window.innerHeight,
  menuOpen: window.innerWidth > 1024,
  bottomBar: true,
  popupOverlay: false,
  mobilePopupOverlay: false,
  browserInfo: detect()
}

export const useBrowserStore = create((set, get) => ({
  ...initialState,

  setWindowSize: (width, height) =>
    set({ windowWidth: width, windowHeight: height }),

  setMenuOpen: (isOpen) => set({ menuOpen: isOpen }),

  setShowBottomBar: (isOpen) => set({ bottomBar: isOpen }),

  setShowPopupOverlay: (isOpen) => set({ popupOverlay: isOpen }),

  setShowMobilePopupOverlay: (isOpen) => set({ mobilePopupOverlay: isOpen }),

  toggleMenu: () => set((state) => ({ menuOpen: !state.menuOpen })),
  closeMenu: () => set({ menuOpen: false }),

  logout: () => set(initialState),

  popupOverlayActions: {
    show: () => set({ popupOverlay: true }),
    hide: () => set({ popupOverlay: false })
  }
}))

// selectors
export const useShowPopupOverlay = () =>
  useBrowserStore((state) => state.popupOverlayActions.show, shallow)

export const useHidePopupOverlay = () =>
  useBrowserStore((state) => state.popupOverlayActions.hide, shallow)

export const useWindowWidth = () =>
  useBrowserStore((state) => state.windowWidth, shallow)

export const useWindowHeight = () =>
  useBrowserStore((state) => state.windowHeight, shallow)

export const useBrowserInfo = () =>
  useBrowserStore((state) => state.browserInfo, shallow)

export const useIsMobile = () => {
  const windowWidth = useWindowWidth()
  const browserInfo = useBrowserInfo()

  const isMobileOS = mobileOSList.includes(browserInfo?.os)

  const isTablet = tabletUserAgent.some((uA) =>
    window.navigator.userAgent.includes(uA)
  )
  return windowWidth < 900 && isMobileOS && !isTablet
}

export const useIsTablet = () => {
  const windowWidth = useWindowWidth()
  const browserInfo = useBrowserInfo()

  const isMobileOS = mobileOSList.includes(browserInfo?.os)
  return windowWidth >= 900 && isMobileOS
}

export const useIsDesktop = () => {
  const windowWidth = useWindowWidth()

  return windowWidth > 1024
}

// Static
const getWindowWidth = () => useBrowserStore.getState().windowWidth ?? null
const getBrowserInfo = () => useBrowserStore.getState().browserInfo ?? null

export const getIsMobile = () => {
  const windowWidth = getWindowWidth()
  const browserInfo = getBrowserInfo()

  const isMobileOS = mobileOSList.includes(browserInfo?.os)

  const isTablet = tabletUserAgent.some((uA) =>
    window.navigator.userAgent.includes(uA)
  )
  return windowWidth < 900 && isMobileOS && !isTablet
}

export const getIsTablet = () => {
  const windowWidth = getWindowWidth()
  const browserInfo = getBrowserInfo()

  const isMobileOS = mobileOSList.includes(browserInfo?.os)
  return windowWidth >= 900 && isMobileOS
}

export const getIsDesktop = () => {
  const windowWidth = getWindowWidth()
  const browserInfo = getBrowserInfo()

  const isMobileOS = mobileOSList.includes(browserInfo?.os)
  return windowWidth >= 900 && isMobileOS
}
